import ProductCard from "../components/ProductCard";
import data from "./data.json";
import { Link, useLocation } from "react-router-dom";
import "./Home.css";
import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import {
  Inbox,
  useAuthenticateUser,
  useFeedClient,
  useSuprSendClient,
  ToastNotificationCard,
  SuprSendI18nProvider,
} from "@suprsend/react";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Home() {
  const [themeType, setThemeType] = useState();
  const [pushSubscribed, setPushSubscribed] = useState(false);

  const ssClient = useSuprSendClient();
  const { authenticatedUser } = useAuthenticateUser();
  let query = useQuery();
  const localtion = useLocation().search;
  const user = JSON.parse(localStorage.getItem("user"));

  React.useEffect(() => {
    const themeType = localStorage.getItem("theme");
    if (themeType) {
      setThemeType(themeType);
    } else {
      setThemeType("light");
    }
    if (authenticatedUser) {
      ssClient.track("Page Load", {
        page: "Home Page",
        userAgent: navigator.userAgent,
      });
    }
    let utm_obj = {
      utm_source: query.get("utm_source"),
      utm_medium: query.get("utm_medium"),
      utm_campaign: query.get("utm_campaign"),
      utm_id: query.get("utm_id"),
      utm_term: query.get("utm_term"),
      utm_content: query.get("utm_content"),
    };
    if (localtion) {
      ssClient.track("UTM Visited", utm_obj);
    }
  }, [authenticatedUser]);

  const tenant = user.tenant;
  let stores = user.tabs;
  let language = user.language;
  let translations = user.translations;
  if (translations) {
    translations = JSON.parse(translations);
  }
  if (stores) {
    stores = JSON.parse(stores);
  }

  return (
    <>
      <div
        className="container"
        style={{ backgroundColor: themeType === "dark" ? "black" : "white" }}
      >
        <div>
          <p className="featured_text">Featured</p>
          <p className="items_count">20 items listed</p>
        </div>
        <div className="flex_container">
          <div className="inbox_container">
            <SuprSendI18nProvider locale={language} translations={translations}>
              <Inbox
                host={{
                  apiHost: process.env.REACT_APP_INBOX_API_HOST,
                  socketHost: process.env.REACT_APP_INBOX_SOCKET_HOST,
                }}
                tenantId={tenant}
                stores={stores}
                themeType={themeType}
              />
            </SuprSendI18nProvider>
          </div>
          <div className="sort_container">
            <img src="./images/sort.png" alt="sort" height={18} width={18} />
            <p className="help_text" onClick={() => {}}>
              Sort
            </p>
          </div>
          <div
            className="filter_img"
            onClick={() => {
              if (themeType === "light") {
                localStorage.setItem("theme", "dark");
                setThemeType("dark");
              } else {
                localStorage.setItem("theme", "light");
                setThemeType("light");
              }
            }}
          >
            <img src="./images/filter.png" alt="sort" height={18} width={18} />
            <p className="help_text">Theme</p>
          </div>
        </div>
      </div>
      {!pushSubscribed && (
        <div className="push_banner" role="region" aria-label="Push notifications">
          <div className="push_banner_text">
            <p className="push_banner_title">Stay in the loop</p>
            <p className="push_banner_subtitle">
              Enable push notifications to get updates on your orders.
            </p>
          </div>
          <button
            className="push_banner_button"
            onClick={async () => {
              const data = await ssClient.webpush.registerPush();
              console.log("response webpush", data);
              setPushSubscribed(true);
            }}
          >
            Subscribe
          </button>
        </div>
      )}
      <div className="product_list">
        {data.map((item) => (
          <ProductCard item={item} key={item.id} />
        ))}
        <Link to="/checkout" className="link">
          <p className="buy_text">Buy Now</p>
        </Link>
      </div>
    </>
  );
}

export default Home;

function ToastNotification() {
  const feedClient = useFeedClient();
  console.log(feedClient?.emitter);

  useEffect(() => {
    if (!feedClient) return;
    feedClient.emitter.on("feed.new_notification", (data) => {
      console.log("received new notification", data);
      toast.custom(
        <div>
          <ToastNotificationCard notificationData={data} disableMarkdown />
        </div>
      );
    });

    return () => {
      console.log("calling the off toast");
      feedClient.emitter.off("feed.new_notification");
    };
  }, [feedClient]);

  return <Toaster />;
}
